import 'babel-polyfill';
import 'react-hot-loader/patch';
import React from 'react';
import ReactDom from 'react-dom';
import { FluxibleComponent } from 'fluxible-addons-react';
import navigateAction from '../actions/navigateAction';
import { passContextToAuditStore } from '../apps/Audit/actions/AuditActionCreators';
import RouteFactory from '../RouteFactory';
import IntlProvider from '../utils/ConnectedIntlProvider';
import googleAnalyticsDecoratorArgs from '../utils/route/googleAnalyticsDecoratorArgs';
import History from './History';
import WebFonts from './WebFonts';
import { browserHistory, RouterContext } from 'react-router';
import { createRouterObject } from 'react-router/lib/RouterUtils';
import createTransitionManager from 'react-router/lib/createTransitionManager';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import fluxibleApp from '../fluxibleApp';
import FluxibleContext from '../utils/FluxibleContext';
import { AppContainer } from 'react-hot-loader';
import { configureUrlQuery } from 'react-url-query';
// Add promise support for browser not supporting it
import es6Promise from 'es6-promise';

WebFonts.init();

es6Promise.polyfill();

extendMoment(Moment);

window.React = React;
// window.document.cookie = `tz=${ 12 - (new Date()).getTimezoneOffset() / 60}`;
window.document.cookie = 'tz=7';

const mountNode = document.getElementById('content');
const dehydratedState = window.__INITIAL_STATE__;

function doRender(context, state, history, router) {
  // noinspection RequiredAttributes
  // FluxibleContext.Provider is added to make context available to functional components
  const Component = (
    <FluxibleContext.Provider value={ context }>
      <IntlProvider>
        <RouterContext history={ history } router={ router } { ...state } />
      </IntlProvider>
    </FluxibleContext.Provider>
  );

  const element = module.hot ? <AppContainer>
    {
      React.createElement(
        FluxibleComponent,
        { context: context.getComponentContext() },
        Component
      )
    }
  </AppContainer> : React.createElement(
    FluxibleComponent,
    { context: context.getComponentContext() },
    Component
  );

  ReactDom.render(
    element,
    mountNode,
    function () {
      console.info('React Render Complete');
    }
  );
}

function renderApp() {
  console.info('Rehydrating state...', dehydratedState);

  fluxibleApp.rehydrate(dehydratedState, (err, context) => {
    if (err) {
      throw err;
    }

    console.info('State has been rehydrated');

    // pass context to audit store so it can access the fetchr audit service directly
    context.executeAction(passContextToAuditStore);

    const routes = new RouteFactory()
      .decoratedWith('getContext', () => context)
      .decoratedWith(...googleAnalyticsDecoratorArgs)
      .create();

    let firstRender = true;

    const initialState = {
      location: null,
      routes: null,
      params: null,
      components: null
    };

    let lastState = initialState;

    const transitionManager = createTransitionManager(browserHistory, routes);
    const router = createRouterObject(browserHistory, transitionManager, initialState);

    History.init(router);

    configureUrlQuery({ history: browserHistory });

    transitionManager.listen((err, state) => {
      if (firstRender) {
        lastState = state;
        doRender(context, state, browserHistory, router);
        firstRender = false;
      } else {
        context.executeAction(navigateAction, state, function () {
          lastState = state;
          doRender(context, state, browserHistory, router);
        });
      }
    });

    if (module.hot) {
      module.hot.accept(module => {
        console.info('Obtained updates for module', {
          module,
          args: arguments
        });
      }, () => {
        console.info('Module hot updated. Rerendering', {
          args: arguments
        });
        doRender(context, lastState, browserHistory, router);
      });
    }
  });
}

renderApp();



// WEBPACK FOOTER //
// ./src/client/index.js